import { ApplyForLeaves } from "../apply-for-leaves.entity";
import { ApplyForLeavesDTO } from "./apply-for-leaves.dto";

export class ApplyForLeavesAdapter {

    convertDtoToEntity(dtoObj: ApplyForLeavesDTO, isUpdate: boolean = false): ApplyForLeaves {
        try {
            const entityObj = new ApplyForLeaves();
            entityObj.applyForLeavesId = dtoObj.applyForLeavesId;
            entityObj.employeeId = dtoObj.employeeId;
            entityObj.employeeCode = dtoObj.employeeCode;
            entityObj.typeOfLeave = dtoObj.typeOfLeave;
            entityObj.employeeName = dtoObj.employeeName;
            entityObj.fromDate = dtoObj.fromDate;
            entityObj.toDate = dtoObj.toDate;
            entityObj.leaveFromDay = dtoObj.leaveFromDay;
            entityObj.appliedDate = dtoObj.appliedDate;
            entityObj.leaveToDay = dtoObj.leaveToDay;
            entityObj.noOfDays = dtoObj.noOfDays;
            entityObj.leaveReason = dtoObj.leaveReason;
            entityObj.leaveAddress = dtoObj.leaveAddress;
            entityObj.status = dtoObj.status;
            entityObj.rejectionReason=dtoObj.rejectionReason;

            if (isUpdate) {
                entityObj.updatedUser = dtoObj.updatedUser;
                // entityObj.rejectionReason=dtoObj.rejectionReason;
            } else {
                entityObj.isActive = true;
                entityObj.createdUser = dtoObj.createdUser;
            }
            return entityObj;
        } catch (error) {
            throw error;
        }
    }

    convertEntityToDto(entityObj: ApplyForLeaves): ApplyForLeavesDTO {

        const dtoObj = new ApplyForLeavesDTO();
        dtoObj.applyForLeavesId = entityObj.applyForLeavesId;
        dtoObj.employeeId = entityObj.employeeId;
        dtoObj.employeeCode = entityObj.employeeCode;
        dtoObj.typeOfLeave = entityObj.typeOfLeave;
        dtoObj.employeeName = entityObj.employeeName;
        dtoObj.fromDate = entityObj.fromDate;
        dtoObj.leaveFromDay = entityObj.leaveFromDay
        dtoObj.leaveToDay = entityObj.leaveToDay;
        dtoObj.leaveReason = entityObj.leaveReason;
        dtoObj.toDate = entityObj.toDate;
        dtoObj.noOfDays = entityObj.noOfDays;
        dtoObj.appliedDate = entityObj.appliedDate;
        dtoObj.leaveAddress = entityObj.leaveAddress;
        dtoObj.isActive = entityObj.isActive;
        dtoObj.createdAt = entityObj.createdAt;
        dtoObj.createdUser = entityObj.createdUser;
        dtoObj.updatedAt = entityObj.updatedAt;
        dtoObj.updatedUser = entityObj.updatedUser;
        dtoObj.versionFlag = entityObj.versionFlag;
        dtoObj.status = entityObj.status;
        dtoObj.rejectionReason=entityObj.rejectionReason;
        return dtoObj;
    }
}